import { createFileRoute } from "@tanstack/react-router";
import PaymentDiscovery from "../../../views/billing/PaymentDiscovery";

export const Route = createFileRoute("/_authenticated/user/plans")({
  component: PaymentDiscovery,
  staticData: { application: "Admin" },
});
